<template>
	<app-page>
		<app-heading :title="listing.name" />
		<app-row>
			<app-cell>
				<app-data-table
					:items="availabilities"
					:headers="headers"
					:total="count"
					sort-by="date"
					@update="fetchAvailabilities"
				>
				</app-data-table>
			</app-cell>
		</app-row>
	</app-page>
</template>

<script>
export default {
	data() {
		return {
			availabilities: [],
			count: -1,
			listing: {
				name: '',
			},
			headers: [{
				text: 'Date',
				value: 'date',
				sortable: true,
				format: 'date',
			}, {
				text: 'Price',
				value: 'price',
				sortable: true,
				cb: item => `${item.price} ${item.currency}`,
			}, {
				text: 'Min nights',
				value: 'min_nights',
				sortable: true,
			}, {
				text: 'Max nights',
				value: 'max_nights',
				sortable: true,
			}, {
				text: 'Actions',
				value: 'actions',
				align: 'end',
				sortable: false,
			}],
		}
	},
	async mounted() {
		this.listing = await this.$ravello.request()
			.v(2)
			.to('markets')
			.to(this.marketId)
			.to('airbnblistings')
			.to(this.id)
			.get()
	},
	computed: {
		marketId() {
			return this.$route.params.market
		},
		id() {
			return this.$route.params.listing
		},
	},
	methods: {
		async fetchAvailabilities(pagination) {
			const request = this.$ravello.graphql('availabilities')
				.parent(this.$ravello.graphql('airbnblisting', this.id)
					.parent(this.$ravello.graphql('market', this.marketId)))
				.fromPagination(pagination)
				.fields(['_id', 'date', 'available', 'currency', 'price', 'min_nights', 'max_nights'])

			if (this.count === -1) {
				request.count('count')
			}
			try {
				this.availabilities = await request.query()
				if (this.count === -1) {
					this.count = request.results.count
				}
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
		},
	},
}
</script>
